// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2305":"7374c24ba3cc18ae","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","5806":"612d2c29b1c1d563","7937":"80e5c0471a7a9b62","8199":"f01407468f07465e"}[chunkId] + ".css";
};